import { fetchApi, getApi } from '@coconut/services/apis/utils';

export const patchBankInfo = (data) =>
  fetchApi('api/v3/tutors/bank', 'PATCH', { data }).then((res) => res.data);

export const fetchBankInfo = () =>
  getApi('api/v3/tutors/bank').then((res) => res.data);



// WEBPACK FOOTER //
// ./src/services/apis/bank.js